"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETelemetryType = void 0;
var ETelemetryType;
(function (ETelemetryType) {
    ETelemetryType["COUNTER"] = "counter";
    ETelemetryType["TIMER"] = "timer";
})(ETelemetryType = exports.ETelemetryType || (exports.ETelemetryType = {}));
//# sourceMappingURL=types.js.map